/**
 * Product Recommendations Smart Buttons
 * Handles add to cart functionality for recommendation cards
 */

(function () {
  "use strict";

  var selectors = {
    addToCartForm: ".card__add-to-cart-form",
    addToCartBtn: ".card__add-to-cart-btn",
    btnText: ".btn__text",
    btnLoading: ".btn__loading",
  };

  var classes = {
    loading: "btn--loading",
    success: "btn--success",
    error: "btn--error",
  };

  function ProductRecommendationsSmartButtons() {
    this.init();
  }

  ProductRecommendationsSmartButtons.prototype = {
    init: function () {
      this.bindEvents();

      // Debug: Check if theme cart system is available
      if (window.theme && window.theme.cart) {
        console.log("Smart Buttons: Theme cart system detected");
      } else {
        console.log("Smart Buttons: Using fallback cart system");
      }
    },

    bindEvents: function () {
      $(document).on(
        "submit",
        selectors.addToCartForm,
        this.handleAddToCart.bind(this)
      );
    },

    handleAddToCart: function (event) {
      event.preventDefault();
      console.log("Smart Buttons: Add to cart clicked");

      var $form = $(event.currentTarget);
      var $button = $form.find(selectors.addToCartBtn);
      var $btnText = $button.find(selectors.btnText);
      var $btnLoading = $button.find(selectors.btnLoading);

      // Show loading state
      this.setButtonState($button, $btnText, $btnLoading, "loading");

      // Get form data
      var formData = new FormData($form[0]);
      console.log("Smart Buttons: Form data prepared");

      // Debug theme cart system availability
      console.log("Smart Buttons: window.theme:", window.theme);
      console.log(
        "Smart Buttons: window.theme.cart:",
        window.theme ? window.theme.cart : "no theme"
      );
      console.log(
        "Smart Buttons: addItemFromForm function:",
        window.theme && window.theme.cart
          ? typeof window.theme.cart.addItemFromForm
          : "no cart"
      );

      // Use existing theme cart system if available
      if (
        window.theme &&
        window.theme.cart &&
        typeof window.theme.cart.addItemFromForm === "function"
      ) {
        console.log("Smart Buttons: Using theme addItemFromForm");

        // Use the exact same method as the existing cart system
        window.theme.cart
          .addItemFromForm(formData)
          .then(
            function (cartState) {
              console.log(
                "Smart Buttons: Theme cart add success, cart state:",
                cartState
              );

              // Ensure cart UI is updated by triggering theme events
              this.triggerThemeCartUpdate(cartState);

              this.onAddToCartSuccess(
                $button,
                $btnText,
                $btnLoading,
                cartState
              );

              // The theme cart system automatically triggers 'change' event
              // which should update the cart drawer automatically
            }.bind(this)
          )
          .catch(
            this.onAddToCartError.bind(this, $button, $btnText, $btnLoading)
          );
      } else {
        console.log("Smart Buttons: Using fallback AJAX");
        // Fallback to direct AJAX call
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
        })
          .done(
            function (addResponse) {
              console.log("Smart Buttons: Add response:", addResponse);

              // After adding item, get the full cart state
              $.get("/cart.js")
                .done(
                  function (response) {
                    // Ensure we have a proper JavaScript object
                    var fullCartState =
                      typeof response === "string"
                        ? JSON.parse(response)
                        : response;
                    console.log(
                      "Smart Buttons: Full cart state after add:",
                      fullCartState
                    );

                    // Try to trigger theme's cart change event first
                    this.triggerThemeCartUpdate(fullCartState);

                    this.onAddToCartSuccess(
                      $button,
                      $btnText,
                      $btnLoading,
                      fullCartState
                    );
                  }.bind(this)
                )
                .fail(
                  function () {
                    // If getting full cart fails, use the add response
                    this.onAddToCartSuccess(
                      $button,
                      $btnText,
                      $btnLoading,
                      addResponse
                    );
                  }.bind(this)
                );
            }.bind(this)
          )
          .fail(
            this.onAddToCartError.bind(this, $button, $btnText, $btnLoading)
          );
      }
    },

    onAddToCartSuccess: function ($button, $btnText, $btnLoading, cartState) {
      console.log("Smart Buttons: Cart add success", cartState);

      // Show success state
      this.setButtonState($button, $btnText, $btnLoading, "success");

      // Update cart UI with the cart state returned by theme system
      if (cartState) {
        this.updateCartUIFromState(cartState);
      }

      // Show success notification
      this.showNotification("商品をカートに追加しました", "success");

      // Reset button after delay
      setTimeout(
        function () {
          this.setButtonState($button, $btnText, $btnLoading, "default");
        }.bind(this),
        2000
      );
    },

    onAddToCartError: function ($button, $btnText, $btnLoading, xhr) {
      // Show error state
      this.setButtonState($button, $btnText, $btnLoading, "error");

      // Parse error message
      var errorMessage = "カートに追加できませんでした";
      try {
        var response = JSON.parse(xhr.responseText);
        if (response.message) {
          errorMessage = response.message;
        } else if (response.description) {
          errorMessage = response.description;
        }
      } catch (e) {
        // Use default error message
      }

      // Show error notification
      this.showNotification(errorMessage, "error");

      // Reset button after delay
      setTimeout(
        function () {
          this.setButtonState($button, $btnText, $btnLoading, "default");
        }.bind(this),
        3000
      );
    },

    setButtonState: function ($button, $btnText, $btnLoading, state) {
      // Remove all state classes
      $button.removeClass(
        [classes.loading, classes.success, classes.error].join(" ")
      );

      switch (state) {
        case "loading":
          $button.addClass(classes.loading).prop("disabled", true);
          $btnText.hide();
          $btnLoading.show();
          break;

        case "success":
          $button.addClass(classes.success).prop("disabled", true);
          $btnText.text("追加完了").show();
          $btnLoading.hide();
          break;

        case "error":
          $button.addClass(classes.error).prop("disabled", true);
          $btnText.text("エラー").show();
          $btnLoading.hide();
          break;

        default:
          $button.prop("disabled", false);
          $btnText.text("カートに追加").show();
          $btnLoading.hide();
          break;
      }
    },

    updateCartCount: function () {
      var self = this;
      console.log("Smart Buttons: Updating cart count...");

      // Use existing theme cart system if available
      if (
        window.theme &&
        window.theme.cart &&
        typeof window.theme.cart.getCart === "function"
      ) {
        console.log("Smart Buttons: Using theme cart system");
        window.theme.cart
          .getCart()
          .then(function (cart) {
            console.log("Smart Buttons: Got cart data from theme", cart);
            self.updateCartUI(cart);
          })
          .catch(function (error) {
            console.log(
              "Smart Buttons: Theme cart error, using fallback",
              error
            );
            $.get("/cart.js").done(function (response) {
              var cart =
                typeof response === "string" ? JSON.parse(response) : response;
              self.updateCartUI(cart);
            });
          });
      } else {
        console.log("Smart Buttons: Using fallback AJAX");
        // Fallback to direct AJAX call
        $.get("/cart.js").done(function (response) {
          var cart =
            typeof response === "string" ? JSON.parse(response) : response;
          console.log("Smart Buttons: Got cart data from AJAX", cart);
          self.updateCartUI(cart);
        });
      }
    },

    triggerThemeCartUpdate: function (cartState) {
      console.log("Smart Buttons: Attempting to trigger theme cart update");

      // Wait for theme to be ready
      var maxAttempts = 10;
      var attempt = 0;

      var tryTriggerUpdate = function () {
        attempt++;

        // Try different ways to access the cart system
        var cartSystem = null;

        if (
          window.theme &&
          window.theme.cart &&
          typeof window.theme.cart.trigger === "function"
        ) {
          cartSystem = window.theme.cart;
          console.log("Smart Buttons: Found theme.cart system");
        } else if (window.cart && typeof window.cart.trigger === "function") {
          cartSystem = window.cart;
          console.log("Smart Buttons: Found global cart system");
        }

        if (cartSystem) {
          try {
            // Trigger the change event that the theme listens for
            cartSystem.trigger("change", cartState);
            console.log(
              "Smart Buttons: Successfully triggered cart change event"
            );

            // Also try to directly update cart drawer
            this.updateCartDrawer(cartState);

            return true;
          } catch (error) {
            console.log("Smart Buttons: Error triggering cart event:", error);
          }
        }

        // If we haven't found the cart system and haven't exceeded max attempts, try again
        if (attempt < maxAttempts) {
          console.log(
            "Smart Buttons: Cart system not ready, retrying in 100ms (attempt " +
              attempt +
              "/" +
              maxAttempts +
              ")"
          );
          setTimeout(tryTriggerUpdate, 100);
        } else {
          console.log(
            "Smart Buttons: Max attempts reached, cart system not available"
          );
          // Try direct cart drawer update as fallback
          this.updateCartDrawer(cartState);
        }

        return false;
      }.bind(this);

      tryTriggerUpdate();
    },

    updateCartDrawer: function (cartState) {
      console.log("Smart Buttons: Attempting to update cart drawer directly");

      // First try the sections system approach
      if (
        window.sections &&
        typeof window.sections.getInstances === "function"
      ) {
        window.sections
          .getInstances("cart-drawer")
          .then(
            function (instances) {
              if (instances && instances.length > 0) {
                var cartDrawerInstance = instances[0];
                console.log("Smart Buttons: Found cart drawer instance");

                if (typeof cartDrawerInstance.update === "function") {
                  console.log(
                    "Smart Buttons: Calling cart drawer update method"
                  );
                  cartDrawerInstance.update(cartState);
                  return; // Success, no need to continue
                }
              }
              // If sections approach fails, try direct HTML update
              this.updateCartDrawerHTML(cartState);
            }.bind(this)
          )
          .catch(
            function (error) {
              console.log(
                "Smart Buttons: Error getting cart drawer instances:",
                error
              );
              // If sections approach fails, try direct HTML update
              this.updateCartDrawerHTML(cartState);
            }.bind(this)
          );
      } else {
        console.log("Smart Buttons: Sections system not available");
        // Try direct HTML update
        this.updateCartDrawerHTML(cartState);
      }
    },

    updateCartDrawerHTML: function (cartState) {
      console.log("Smart Buttons: Updating cart drawer HTML directly");

      var $cartDrawer = $(".cart-drawer");
      if ($cartDrawer.length === 0) {
        console.log("Smart Buttons: Cart drawer element not found");
        return;
      }

      // Update empty state
      if (cartState.items && cartState.items.length > 0) {
        $cartDrawer.removeClass("cart-drawer--empty");
        console.log("Smart Buttons: Removed empty class from cart drawer");
      } else {
        $cartDrawer.addClass("cart-drawer--empty");
        console.log("Smart Buttons: Added empty class to cart drawer");
        return; // No items to display
      }

      // Update subtotal
      var $subtotal = $cartDrawer.find("[data-cart-subtotal]");
      if ($subtotal.length > 0 && cartState.total_price) {
        // Format price (assuming JPY currency)
        var formattedPrice =
          "¥" + (cartState.total_price / 100).toLocaleString();
        $subtotal.text(formattedPrice);
        console.log("Smart Buttons: Updated subtotal to:", formattedPrice);
      }

      // Update checkout button state
      var $checkoutBtn = $cartDrawer.find("[data-cart-submit]");
      if ($checkoutBtn.length > 0) {
        if (cartState.items && cartState.items.length > 0) {
          $checkoutBtn.prop("disabled", false);
          console.log("Smart Buttons: Enabled checkout button");
        } else {
          $checkoutBtn.prop("disabled", true);
          console.log("Smart Buttons: Disabled checkout button");
        }
      }

      // Try to add the new item to the cart drawer item list
      this.addItemToCartDrawer(cartState);
    },

    addItemToCartDrawer: function (cartState) {
      console.log("Smart Buttons: Adding new items to cart drawer");

      if (!cartState.items || cartState.items.length === 0) {
        console.log("Smart Buttons: No items to add");
        return;
      }

      var $itemList = $(".cart-drawer__item-list");
      if ($itemList.length === 0) {
        console.log("Smart Buttons: Cart drawer item list not found");
        return;
      }

      // Get existing item keys to avoid duplicates
      var existingKeys = [];
      $itemList.find("[data-cart-item-id]").each(function () {
        var key = $(this).attr("data-cart-item-id");
        if (key) {
          existingKeys.push(key);
        }
      });

      console.log("Smart Buttons: Existing item keys:", existingKeys);

      // Find the correct insertion point (before paperbag div)
      var $paperbag = $itemList.find(".paperbag");
      console.log("Smart Buttons: Found paperbag elements:", $paperbag.length);
      console.log("Smart Buttons: Item list HTML:", $itemList.html());

      var insertionPoint = $paperbag.length > 0 ? $paperbag : null;
      console.log(
        "Smart Buttons: Insertion point found:",
        insertionPoint ? "yes" : "no"
      );

      // Add new items that don't exist yet
      cartState.items.forEach(
        function (item, index) {
          if (existingKeys.indexOf(item.key) === -1) {
            console.log("Smart Buttons: Adding new item:", item.product_title);
            var itemHtml = this.createCartItemHTML(item, index + 1);

            // Try multiple insertion strategies
            var inserted = false;

            // Strategy 1: Insert before paperbag
            if (insertionPoint) {
              insertionPoint.before(itemHtml);
              console.log("Smart Buttons: Inserted item before paperbag");
              inserted = true;
            }
            // Strategy 2: Insert after last cart item (excluding template)
            else {
              var $lastCartItem = $itemList
                .find(
                  ".cart-drawer__item[data-cart-item]:not(.ajax-cart__template)"
                )
                .last();
              console.log(
                "Smart Buttons: Found last cart items:",
                $lastCartItem.length
              );
              if ($lastCartItem.length > 0) {
                $lastCartItem.after(itemHtml);
                console.log(
                  "Smart Buttons: Inserted item after last cart item"
                );
                inserted = true;
              }
              // Strategy 2b: Insert after template item if no real items exist
              else {
                var $templateItem = $itemList
                  .find(".cart-drawer__item.ajax-cart__template")
                  .first();
                console.log(
                  "Smart Buttons: Found template items:",
                  $templateItem.length
                );
                if ($templateItem.length > 0) {
                  $templateItem.after(itemHtml);
                  console.log(
                    "Smart Buttons: Inserted item after template item"
                  );
                  inserted = true;
                }
              }
            }

            // Strategy 3: Fallback - append to end
            if (!inserted) {
              $itemList.append(itemHtml);
              console.log("Smart Buttons: Appended item to end (fallback)");
            }
          } else {
            // Update existing item quantity and price
            console.log(
              "Smart Buttons: Updating existing item:",
              item.product_title,
              "quantity:",
              item.quantity
            );
            this.updateExistingCartItem(item, cartState);
          }
        }.bind(this)
      );
    },

    updateExistingCartItem: function (item, cartState) {
      console.log("Smart Buttons: Updating existing cart item:", item.key);

      var $existingItem = $(".cart-drawer__item-list").find(
        '[data-cart-item-id="' + item.key + '"]'
      );
      if ($existingItem.length === 0) {
        console.log("Smart Buttons: Existing item not found in DOM");
        return;
      }

      // Update quantity input
      var $quantityInput = $existingItem.find(".cart-drawer__item-quantity");
      if ($quantityInput.length > 0) {
        $quantityInput.val(item.quantity);
        console.log("Smart Buttons: Updated quantity to:", item.quantity);
      }

      // Update price if needed (in case of discounts)
      var $priceContainer = $existingItem.find(
        "[data-cart-item-price-container]"
      );
      if ($priceContainer.length > 0) {
        var formattedPrice = "¥" + (item.final_price / 100).toLocaleString();
        var originalFormattedPrice =
          "¥" + (item.original_price / 100).toLocaleString();

        var priceHTML =
          item.original_price !== item.final_price
            ? '<span class="visually-hidden">通常価格</span>' +
              '<del class="cart-item__original-price">' +
              originalFormattedPrice +
              "</del>" +
              '<span class="visually-hidden">セール価格</span>' +
              '<span class="order-discount cart-item__price">' +
              formattedPrice +
              "</span>"
            : '<span class="cart-item__original-price cart-item__price">' +
              formattedPrice +
              "</span>";

        $priceContainer.html(priceHTML);
        console.log("Smart Buttons: Updated price to:", formattedPrice);
      }

      // Update line number attribute
      $existingItem.attr(
        "data-cart-item-line-number",
        this.getItemLineNumber(item, cartState)
      );
    },

    getItemLineNumber: function (targetItem, cartState) {
      for (var i = 0; i < cartState.items.length; i++) {
        if (cartState.items[i].key === targetItem.key) {
          return i + 1;
        }
      }
      return 1;
    },

    createCartItemHTML: function (item, lineNumber) {
      console.log("Smart Buttons: Creating HTML for item:", item.product_title);

      // Format price
      var formattedPrice = "¥" + (item.final_price / 100).toLocaleString();
      var originalFormattedPrice =
        "¥" + (item.original_price / 100).toLocaleString();

      // Create item HTML based on the cart-drawer.liquid structure
      var imageUrl = item.featured_image ? item.featured_image.url : item.image;
      var variantTitle =
        item.variant_title && item.variant_title !== "Default Title"
          ? item.variant_title
          : "";
      var priceHTML =
        item.original_price !== item.final_price
          ? '<span class="visually-hidden">通常価格</span>' +
            '<del class="cart-item__original-price">' +
            originalFormattedPrice +
            "</del>" +
            '<span class="visually-hidden">セール価格</span>' +
            '<span class="order-discount cart-item__price">' +
            formattedPrice +
            "</span>"
          : '<span class="cart-item__original-price cart-item__price">' +
            formattedPrice +
            "</span>";

      var itemHtml =
        '<div class="cart-drawer__item" data-cart-item data-cart-item-id="' +
        item.key +
        '" data-cart-item-line-number="' +
        lineNumber +
        '" aria-live="polite">' +
        '<a href="' +
        item.url +
        '" class="cart-drawer__item-image" style="background-image: url(\'' +
        imageUrl +
        "');\" data-cart-item-background-image data-cart-item-href></a>" +
        '<div class="cart-drawer__item-content">' +
        '<a href="' +
        item.url +
        '" class="h4 cart-drawer__item-title" data-cart-item-href data-cart-item-title>' +
        item.product_title +
        "</a>" +
        '<p class="cart-drawer__item-subtitle" data-cart-item-variant-title>' +
        variantTitle +
        "</p>" +
        '<ul class="cart-drawer__item-properties" data-cart-item-details-list>' +
        this.createItemPropertiesHTML(item) +
        "</ul>" +
        '<p class="cart-drawer__item-price-container" data-cart-item-price-container>' +
        priceHTML +
        "</p>" +
        '<ul class="order-discount order-discount--list order-discount--title order-discount--cart" data-cart-item-discount-list>' +
        this.createItemDiscountsHTML(item) +
        "</ul>" +
        '<button class="cart-drawer__item-delete btn-link" type="button" data-cart-item-delete>削除</button>' +
        '<label for="quantity_' +
        item.key +
        '" class="label--hidden" data-cart-item-label-quantity">商品の数量</label>' +
        '<input id="quantity_' +
        item.key +
        '" class="cart-drawer__item-quantity" value="' +
        item.quantity +
        '" type="number" pattern="\\d*" min="1" data-cart-item-input-quantity>' +
        "</div>" +
        '<p class="cart-item__message text-center" aria-hidden="true" data-item-message></p>' +
        "</div>";

      return itemHtml;
    },

    createItemPropertiesHTML: function (item) {
      if (!item.properties || Object.keys(item.properties).length === 0) {
        return "";
      }

      var propertiesHTML = "";
      for (var key in item.properties) {
        if (
          item.properties.hasOwnProperty(key) &&
          item.properties[key] &&
          !key.startsWith("_")
        ) {
          var value = item.properties[key];
          if (value.includes("/uploads/")) {
            value = `<a href="${value}">${value.split("/").pop()}</a>`;
          }
          propertiesHTML +=
            '<li class="cart-drawer__item-property" data-cart-item-property">' +
            key +
            ": " +
            value +
            "</li>";
        }
      }
      return propertiesHTML;
    },

    createItemDiscountsHTML: function (item) {
      if (
        !item.line_level_discount_allocations ||
        item.line_level_discount_allocations.length === 0
      ) {
        return "";
      }

      var discountsHTML = "";
      item.line_level_discount_allocations.forEach(function (discount) {
        var discountAmount = "¥" + (discount.amount / 100).toLocaleString();
        discountsHTML +=
          '<li class="order-discount__item" data-cart-item-discount>' +
          '<span data-cart-item-discount-title">' +
          discount.discount_application.title +
          '</span> (-<span data-cart-item-discount-amount">' +
          discountAmount +
          "</span>)" +
          "</li>";
      });
      return discountsHTML;
    },

    reloadCartDrawerSection: function () {
      console.log(
        "Smart Buttons: DISABLED - reloadCartDrawerSection was causing page to go blank"
      );
      // DISABLED: This function was causing the entire page to go blank
      // The issue was likely with replaceWith() replacing more than intended
      return;

      /*
      // ORIGINAL CODE - DISABLED FOR SAFETY
      console.log("Smart Buttons: Attempting to reload cart drawer section");

      // Try to reload the cart drawer section using Shopify's section rendering
      $.get(window.location.href + "?section_id=cart-drawer")
        .done(function (html) {
          console.log("Smart Buttons: Got fresh cart drawer HTML");

          var $newCartDrawer = $(html);
          var $currentCartDrawer = $(".cart-drawer");

          if ($currentCartDrawer.length > 0 && $newCartDrawer.length > 0) {
            // Replace the cart drawer content
            $currentCartDrawer.replaceWith($newCartDrawer);
            console.log(
              "Smart Buttons: Replaced cart drawer with fresh content"
            );
          }
        })
        .fail(function () {
          console.log("Smart Buttons: Failed to reload cart drawer section");
        });
      */
    },

    forceCartDrawerRefresh: function () {
      console.log("Smart Buttons: Force refreshing cart drawer");

      // Get fresh cart data and manually update the drawer
      $.get("/cart.js")
        .done(
          function (response) {
            var cartState =
              typeof response === "string" ? JSON.parse(response) : response;
            console.log("Smart Buttons: Got fresh cart data for drawer update");

            // Try to access cart drawer instance again with fresh data
            if (
              window.sections &&
              typeof window.sections.getInstances === "function"
            ) {
              window.sections
                .getInstances("cart-drawer")
                .then(function (instances) {
                  if (instances && instances.length > 0) {
                    var cartDrawerInstance = instances[0];
                    if (typeof cartDrawerInstance.refresh === "function") {
                      console.log(
                        "Smart Buttons: Calling cart drawer refresh method"
                      );
                      cartDrawerInstance.refresh();
                    } else if (
                      typeof cartDrawerInstance.update === "function"
                    ) {
                      console.log(
                        "Smart Buttons: Calling cart drawer update with fresh data"
                      );
                      cartDrawerInstance.update(cartState);
                    }
                  }
                })
                .catch(function (error) {
                  console.log("Smart Buttons: Error in force refresh:", error);
                });
            } else {
              // If sections system is not available, try direct HTML update
              this.updateCartDrawerHTML(cartState);
            }
          }.bind(this)
        )
        .fail(function () {
          console.log("Smart Buttons: Failed to get fresh cart data");
        });
    },

    updateCartUIFromState: function (cartState) {
      console.log(
        "Smart Buttons: Updating cart UI from theme cart state:",
        cartState
      );

      // Debug cart state properties
      console.log("Smart Buttons: cartState.item_count:", cartState.item_count);
      console.log(
        "Smart Buttons: cartState.items_count:",
        cartState.items_count
      );
      console.log("Smart Buttons: cartState.items:", cartState.items);
      console.log(
        "Smart Buttons: cartState.items length:",
        cartState.items ? cartState.items.length : "no items"
      );

      var itemCount =
        cartState.item_count ||
        cartState.items_count ||
        (cartState.items ? cartState.items.length : 0);
      itemCount = parseInt(itemCount, 10) || 0;

      console.log("Smart Buttons: Final calculated item count:", itemCount);

      // Update cart bubble visibility
      var $cartBubble = $(".site-header__cart-bubble");
      console.log(
        "Smart Buttons: Found cart bubble elements:",
        $cartBubble.length
      );
      console.log(
        "Smart Buttons: Current cart bubble classes:",
        $cartBubble.attr("class")
      );

      if (itemCount > 0) {
        $cartBubble.addClass("site-header__cart-bubble--visible");
        console.log("Smart Buttons: Added visible class to cart bubble");
        console.log(
          "Smart Buttons: Cart bubble classes after add:",
          $cartBubble.attr("class")
        );
      } else {
        $cartBubble.removeClass("site-header__cart-bubble--visible");
        console.log("Smart Buttons: Removed visible class from cart bubble");
        console.log(
          "Smart Buttons: Cart bubble classes after remove:",
          $cartBubble.attr("class")
        );
      }

      // Manually trigger the same events that the theme cart system triggers
      if (window.theme && window.theme.cart) {
        console.log(
          "Smart Buttons: Triggering theme cart change event manually"
        );
        if (typeof window.theme.cart.trigger === "function") {
          window.theme.cart.trigger("change", cartState);
        }

        // Also trigger the cart events that update the drawer
        $(window.theme.cart).trigger("change", [cartState]);
      }

      // Trigger additional events for cart drawer update
      $(document).trigger("cart:updated", [cartState]);
      $(document).trigger("cart:change", [cartState]);

      console.log("Smart Buttons: Triggered all cart update events");
    },

    updateCartUI: function (response) {
      console.log("Smart Buttons: Updating cart UI with response:", response);

      // Ensure we have a proper JavaScript object
      var cart = typeof response === "string" ? JSON.parse(response) : response;
      console.log("Smart Buttons: Parsed cart object:", cart);

      // Update cart bubble visibility
      var $cartBubble = $(".site-header__cart-bubble");
      console.log(
        "Smart Buttons: Found cart bubble elements:",
        $cartBubble.length
      );

      console.log(
        "Smart Buttons: Cart item count:",
        cart.item_count,
        "Type:",
        typeof cart.item_count
      );
      console.log(
        "Smart Buttons: Cart items length:",
        cart.items ? cart.items.length : "no items"
      );

      // Try multiple ways to get item count
      var itemCount =
        cart.item_count ||
        cart.items_count ||
        (cart.items ? cart.items.length : 0);
      itemCount = parseInt(itemCount, 10) || 0;
      console.log("Smart Buttons: Final parsed item count:", itemCount);

      if (itemCount > 0) {
        $cartBubble.addClass("site-header__cart-bubble--visible");
        console.log("Smart Buttons: Added visible class to cart bubble");
      } else {
        $cartBubble.removeClass("site-header__cart-bubble--visible");
        console.log("Smart Buttons: Removed visible class from cart bubble");
      }

      // Try to trigger theme cart update
      this.triggerThemeCartUpdate(cart);

      // Update cart count if element exists - try multiple selectors
      var $cartCount = $("[data-cart-count]");
      if ($cartCount.length === 0) {
        $cartCount = $(
          ".cart-count, .site-header__cart-count, [data-cart-item-count]"
        );
      }
      console.log(
        "Smart Buttons: Found cart count elements:",
        $cartCount.length
      );
      if ($cartCount.length) {
        $cartCount.text(itemCount);
        console.log("Smart Buttons: Updated cart count to:", itemCount);
      }

      // Trigger existing theme cart events
      if (
        window.theme &&
        window.theme.cart &&
        typeof window.theme.cart.trigger === "function"
      ) {
        console.log("Smart Buttons: Triggering theme cart change event");
        window.theme.cart.trigger("change", [cart]);
      }

      // Update cart drawer if it exists
      console.log("Smart Buttons: Checking for cart drawer...");
      console.log(
        "Smart Buttons: sections available:",
        typeof sections !== "undefined"
      );
      if (typeof sections !== "undefined") {
        console.log("Smart Buttons: sections.instances:", sections.instances);
      }

      if (
        typeof sections !== "undefined" &&
        sections.instances &&
        sections.instances["cart-drawer"]
      ) {
        console.log("Smart Buttons: Found cart drawer, attempting refresh");
        if (typeof sections.instances["cart-drawer"].refresh === "function") {
          sections.instances["cart-drawer"].refresh();
          console.log("Smart Buttons: Called cart drawer refresh");
        } else if (
          typeof sections.instances["cart-drawer"].update === "function"
        ) {
          sections.instances["cart-drawer"].update(cart);
          console.log("Smart Buttons: Called cart drawer update");
        }
      } else {
        console.log(
          "Smart Buttons: Cart drawer not found, trying alternative methods"
        );

        // Try to find and update cart drawer manually
        var $cartDrawer = $(".cart-drawer, .drawer, [data-cart-drawer]");
        if ($cartDrawer.length) {
          console.log(
            "Smart Buttons: Found cart drawer element, triggering manual update"
          );

          // Try multiple events to trigger cart update
          $(document).trigger("cart:change", [cart]);
          $(document).trigger("cart:updated", [cart]);

          // Try to trigger existing theme events
          if (window.theme && window.theme.cart) {
            if (typeof window.theme.cart.trigger === "function") {
              window.theme.cart.trigger("change", [cart]);
            }
          }

          // Force refresh cart drawer content by reloading it
          setTimeout(function () {
            $.get("/cart.js").done(function (freshCart) {
              console.log(
                "Smart Buttons: Got fresh cart data for drawer update:",
                freshCart
              );
              $(document).trigger("cart:refresh", [freshCart]);
            });
          }, 100);
        }
      }

      // Trigger generic cart update event for other components
      $(document).trigger("cart:updated", [cart]);
      console.log("Smart Buttons: Triggered cart:updated event");
    },

    showNotification: function (message, type) {
      // Create notification element
      var $notification = $(
        '<div class="cart-notification cart-notification--' +
          type +
          '">' +
          message +
          "</div>"
      );

      // Add to page
      $("body").append($notification);

      // Show notification
      setTimeout(function () {
        $notification.addClass("cart-notification--visible");
      }, 100);

      // Hide and remove notification
      setTimeout(function () {
        $notification.removeClass("cart-notification--visible");
        setTimeout(function () {
          $notification.remove();
        }, 300);
      }, 3000);
    },
  };

  // Initialize when DOM is ready
  $(document).ready(function () {
    new ProductRecommendationsSmartButtons();

    // Also setup cart drawer refresh hook
    if (
      typeof SmartButtonsCartHelper !== "undefined" &&
      SmartButtonsCartHelper.setupCartDrawerRefreshHook
    ) {
      SmartButtonsCartHelper.setupCartDrawerRefreshHook();
    }
  });
})();

// Cart drawer refresh functionality
window.SmartButtonsCartHelper = {
  setupCartDrawerRefreshHook: function () {
    console.log("Smart Buttons: Setting up cart drawer refresh hook");

    // Listen for cart drawer open events
    $(document).on("drawer_open_start", function () {
      console.log("Smart Buttons: Cart drawer opening, refreshing content");

      // Get fresh cart data when drawer opens
      $.get("/cart.js").done(function (response) {
        var cartState =
          typeof response === "string" ? JSON.parse(response) : response;

        // Try to update the drawer with fresh data
        if (
          window.sections &&
          typeof window.sections.getInstances === "function"
        ) {
          window.sections
            .getInstances("cart-drawer")
            .then(function (instances) {
              if (
                instances &&
                instances.length > 0 &&
                typeof instances[0].update === "function"
              ) {
                instances[0].update(cartState);
                console.log("Smart Buttons: Updated cart drawer on open");
              }
            });
        }
      });
    });

    // Also listen for cart toggle clicks
    $(document).on(
      "click",
      ".ajax-cart__toggle, [data-cart-toggle]",
      function () {
        console.log("Smart Buttons: Cart toggle clicked, will refresh on open");

        // Small delay to allow drawer to start opening
        setTimeout(function () {
          $.get("/cart.js").done(function (response) {
            var cartState =
              typeof response === "string" ? JSON.parse(response) : response;

            if (
              window.sections &&
              typeof window.sections.getInstances === "function"
            ) {
              window.sections
                .getInstances("cart-drawer")
                .then(function (instances) {
                  if (
                    instances &&
                    instances.length > 0 &&
                    typeof instances[0].update === "function"
                  ) {
                    instances[0].update(cartState);
                    console.log(
                      "Smart Buttons: Updated cart drawer after toggle click"
                    );
                  }
                });
            }
          });
        }, 100);
      }
    );
  },
};
